import { ComposerTranslation } from 'vue-i18n';

export const handleServerErrors = (
  t: ComposerTranslation,
  error: string
): string => {
  let errorMessage = t('unknownError');
  if (error.includes('CodeMetaInformations already exists'))
    errorMessage = t('filtersNameDuplicate');
  else if (error.includes('Lua reserved keyword'))
    errorMessage = t('reservedKeywordsError');
  else if (error.includes('Attribute/filter is referenced by other entities'))
    errorMessage = t('entityReferenceError');
  else if (
    error.includes(
      'Attribute/Filter Name already in use. Please select a different name.'
    )
  )
    errorMessage = error;
  return errorMessage;
};
